export default "__VITE_ASSET__CzrrVmCK__"